export const getNestedObjectFieldsSum = (toCalculateFields: object, omittedFields: string[]): number => {
  return Object.entries(toCalculateFields).reduce((total, [key, value]) => {
    if (omittedFields.includes(key)) {
      return total;
    }
    if (typeof value === 'object') {
      return total + getNestedObjectFieldsSum(value, omittedFields);
    }
    const num = Number(value);
    if (!isNaN(num)) {
      return total + num;
    }
    return total;
  }, 0);
};
